import { useState, useEffect } from "react";
import { getUserData } from "../../utils/api/getUserData.js";
import { updateSettings } from "../../utils/api/updateSettings.js";
import { updatePassword } from "../../utils/api/updatePassword.js";

export function ProfilePage2(user) {

  const [userData, setUserData] = useState({
    user_name: "",
    email: ""
  })

  const [currentPass, setCurrentPass] = useState()
  const [newPass, setNewPass] = useState()
  const [newPass2, setNewPass2] = useState()

  useEffect(() => {
    // cargar datos de usuario
    loadUserData();
  }, []);

  const loadUserData = async () => {
    const loadedUserData = await getUserData(user);

    setUserData((prevUser) => ({
      ...prevUser,  
      user_name: loadedUserData.data.username,
      email: loadedUserData.data.email,
    }));
  }

  const handleUsernameChange = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      user_name: newName,
    }));
  };

  const handleEmailChange = (event) => {
    const newEmail = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      email: newEmail,
    }));
  };

  const handleEditSettings = async () => {
    const response = await updateSettings(user, userData);
    if(response){

    }
  }


  const handleEditPassword = async () => {
    const response = await updatePassword(user, currentPass, newPass, newPass2);
    if(response){

    }
  }

  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
            <br/>
            <span className="ht-body-bold uppercase" >Ajustes de cuenta</span><br/>
            <span className="ht-body-regular">Edita tu contraseña, tu email o tu nickname</span>
          </header>
          <div className="m-frmGroup total">
            <label for="username">Nombre de usuario</label>
            <input placeholder="Nombre de usuario" type="text"  name="user[user_name]" id="user_user_name" value={userData.user_name} onChange={handleUsernameChange}/>
          </div>
          <div className="m-frmGroup total">
            <label for="username">email</label>
            <input placeholder="email" type="text"  name="user[email]" id="user_email" value={userData.email} onChange={handleEmailChange}/>
          </div>
          <button onClick={() => handleEditSettings()} class="btnOrange-l">Guardar</button>


          <div class="m-frmGroup total">
            <p class="ht-body-bold">Cambia tu contraseña</p>
          </div>
          <div className="m-frmGroup total">
            <label for="actual_pass">Contraseña actual</label>
            <input type="password" placeholder="Contraseña actual"   name="actual_pass" id="actual_pass" value={currentPass} onChange={(e)=>{setCurrentPass(e.value)}}/>
          </div>
          <div className="m-frmGroup total">
            <label for="username">Nueva contraseña</label>
            <input type="password" placeholder="Nueva contraseña"   name="newPass" id="newPass" value={newPass} onChange={(e)=>{setNewPass(e.value)}}/>
          </div>
          <div className="m-frmGroup total">
            <label for="username">Repetir contraseña</label>
            <input type="password" placeholder="Repetir contraseña"   name="newPass2" id="newPass2" value={newPass2} onChange={(e)=>{setNewPass2(e.value)}}/>
          </div>
          <button onClick={() => handleEditPassword()} class="btnOrange-l">Guardar</button>
        </div>
      </div>
    </>
  )
}